'use client';

import { useEffect } from 'react';
import { performanceMonitor } from '../lib/performance';

export function PerformanceTracker() {
  useEffect(() => {
    // Initialize performance monitoring
    performanceMonitor.trackWebVitals();
    performanceMonitor.trackResourceTiming();
    performanceMonitor.preloadCriticalResources();
    performanceMonitor.lazyLoadResources();
  }, []);

  return null;
}